import type { SentryErrorBoundaryProps } from '@platform/core/sentry/sentry-error-boundary';
import { SentryErrorBoundary } from '@platform/core/sentry/sentry-error-boundary';

import { ErrorSadWolf } from '@packages/fenrir/feedback/errors/error-sad-wolf';

type ErrorBoundarySadWolfProps = Omit<SentryErrorBoundaryProps, 'fallback'>;

export const ErrorBoundarySadWolf = (props: ErrorBoundarySadWolfProps) => (
  <SentryErrorBoundary fallback={<ErrorSadWolf />} {...props} />
);
